import { combineReducers } from '@reduxjs/toolkit';
import portfolioSiteExplorerReducer from 'src/app/portfolio/views/portfolio-site-explorer/state/portfolioSiteExplorerSlice';
import portfolioFilesReducer from 'src/app/portfolio/views/portfolio-files/state/portfolioFilesSlice';
import gnrFiltersReducer from 'src/app/portfolio/views/global-nature-risk/state/gnrFiltersSlice';
import portfolioGeneralReducer from './portfolioGeneralSlice';

export const portfolio = combineReducers({
    portfolioGeneral: portfolioGeneralReducer,
    portfolioSiteExplorer: portfolioSiteExplorerReducer,
    portfolioFiles: portfolioFilesReducer,
    gnrFilters: gnrFiltersReducer,
});

export default portfolio;
